<section class="d-flex">
  <div class="m-auto d-flex flex-column">
    <fa-icon
      [icon]="['fas', 'spinner']"
      animation="spin-pulse"
      class="m-auto"
    ></fa-icon>
    @if ((isLoaded$ | async) === false) {
    <span i18n="@@accountsLoading"> Loading accounts... </span>
    }
  </div>

  @if ((isLoaded$ | async) === false) {
  <div class="modal-backdrop fade show"></div>
  }
</section>

<epc-merchandise-background></epc-merchandise-background>
